export const NUM_SEARCH_RESULTS_TO_CHECK = 20;
export const RESTRICTION_FEE_THRESHOLD = 0.2;
export const hasVehicleSizeRestrictionsorOversizeFees = (vehiclePolicy) => {
    if (!vehiclePolicy)
        return false;
    const { dimensionRestrictions, oversizeVehiclePolicy } = vehiclePolicy;
    const hasDimensionRestrictions = dimensionRestrictions !== null &&
        (dimensionRestrictions.maxHeight !== 0 ||
            dimensionRestrictions.maxLength !== 0 ||
            dimensionRestrictions.maxWidth !== 0);
    const hasOversizeFees = oversizeVehiclePolicy !== null &&
        Boolean(oversizeVehiclePolicy?.onsiteFee) &&
        oversizeVehiclePolicy?.onsiteFee?.value !== 0;
    return hasDimensionRestrictions || hasOversizeFees;
};
export const showVehicleTooltip = (spots) => {
    const spotsWithRestrictions = spots
        .slice(0, NUM_SEARCH_RESULTS_TO_CHECK)
        .filter(spot => {
        return hasVehicleSizeRestrictionsorOversizeFees(spot.vehiclePolicy);
    });
    return (spotsWithRestrictions.length / NUM_SEARCH_RESULTS_TO_CHECK >=
        RESTRICTION_FEE_THRESHOLD);
};
